import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import {
  DELETE_DEPARTMENT_REQUEST,
  GET_ALL_DEPARTMENT_LIST_REQUEST,
} from "../../../../../../Utils/Constant";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";
import {ItemsCategoryColumns } from "./DepartmentsColumns";
import { useNavigate } from "react-router-dom";
import ConfirmationATM from "../../../../../../Common/ConfirmationATM";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import { hasDeleteAccess, hasEditAccess } from "../../../../../../Common/CheckAccess";

const RestaurantCategoryTable = ({ setSelectedDepartment, onOpenCategoryDrawer, onOpenInventoryDrawer }) => {
  const dispatch = useDispatch();

  const [categoryData, setCategoryData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [globalFilter, setGlobalFilter] = useState("");
  const [gloablFilterType, setGloablFilterType] = useState("name");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const navigate = useNavigate();

 const [permissions, setPermissions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  const {
    departmentList,
    loading,
    addDepartment,
    updateDepartment,
    deleteDepartment,
  } = useSelector((state) => state.department);

  useEffect(() => {
    dispatch({
      type: GET_ALL_DEPARTMENT_LIST_REQUEST,
      payload: { page, limit: pageSize, sortBy, sortOrder, name: globalFilter },
    });
  }, [
    dispatch,
    page,
    pageSize,
    sortBy,
    sortOrder,
    addDepartment,
    updateDepartment,
    deleteDepartment,
    globalFilter,
  ]);

  const handleDelete = (selectData) => {
    setSelectedUser(selectData);
    setShowDeleteModal(true);
  };

  useEffect(() => {
    if (departmentList?.data?.departments?.length) {
      const transformed = departmentList?.data?.departments?.map((data) => ({
        name: data.name || "N/A",
        description: data.description || "N/A",
        // created_at: data.created_at?.split("T")[0] || "N/A",
        department_Category: (
          <>
            <span
              className="btn"
              onClick={() => {
                navigate(`/department/category/${data?.id}`);
              }}
            >
              View
            </span>
          </>
        ),
        actions: (
          <>
            {hasDeleteAccess(permissions, "inventory") &&<button
              className="btn"
              data-toggle="modal"
              data-target="#deleteGuest"
              onClick={() => handleDelete(data)}
            >
              <i className="bi bi-trash text-danger"></i>
            </button>}
            <button
              data-bs-toggle="offcanvas"
              data-bs-target="#add-department"
              aria-controls="add-department"
              className="btn"
              disabled={!hasEditAccess(permissions, "inventory")}
              onClick={() => setSelectedDepartment(data)}
            >
              <i className="bi bi-pencil text-primary"></i>
            </button>
          </>
        ),
        quick_actions: (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => onOpenCategoryDrawer(data)}
            >
              Add Category
            </button>
            <button
              className="btn btn-sm btn-outline-success"
              onClick={() => onOpenInventoryDrawer(data)}
            >
              Add Inventory Items
            </button>
          </div>
        ),
      }));

      setCategoryData(transformed);
    } else {
      setCategoryData([]);
    }
  }, [openMenuId, departmentList]);

  const handleSortChange = (sort) => {
    setSortBy(sort.id);
    setSortOrder(sort.desc ? "desc" : "asc");
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Extract total entries and total pages from API pagination info
  const totalEntries = departmentList?.data?.pagination?.totalResults || 0;
  const totalPages = departmentList?.data?.pagination?.totalPages || 1;

  const confirmDelete = () => {
    dispatch({
      type: DELETE_DEPARTMENT_REQUEST,
      payload: { id: selectedUser?.id },
    });
    setShowDeleteModal(false);
  };

  return (
    <div>
      <DataTableHeader
        pageSize={pageSize}
        setPageSize={setPageSize}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        setCurrentPage={setPage}
        gloablFilterType={gloablFilterType}
        setGloablFilterType={setGloablFilterType}
        flage="category"
      />
      <DataTable
        columns={ItemsCategoryColumns}
        data={categoryData}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSortChange={handleSortChange}
        isLoading={loading}
      />
      <DataTableFooter
        currentPage={page}
        totalPages={totalPages}
        setCurrentPage={handlePageChange}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />
      <ConfirmationATM
        show={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedUser("");
        }}
        onConfirm={confirmDelete}
        message={`Are you sure you want to delete ${selectedUser?.name} ?`}
      />
    </div>
  );
};

export default RestaurantCategoryTable;
